






































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ExistingAsset from './ExistingAsset.vue'
import SelectedAsset from './SelectedAsset.vue'
import { upload } from '@/utilities/asset-helpers'
import { Prototype } from '@shared/types/graphql'
import A from '@/utilities/alpha'
import { Button } from '@alpha/ink'

export const Mode = {
  URL: 'URL',
  EXISTING: 'EXISTING'
}

export const emptyLink = () => ({
  title: '',
  url: ''
})

@Component({
  components: {
    ExistingAsset,
    SelectedAsset,
    Button
  }
})
export default class Attach extends Vue {
  @Prop({ default: () => ({}) }) assets!: Record<string, Prototype>
  @Prop({ default: null }) selectedAssetId!: string | null
  @Prop({ default: null }) mode!: string | null
  @Prop({ default: true }) editable!: boolean

  currentMode = this.mode
  selectedExistingAssetID: string | null = null
  link = emptyLink()
  submitted = false
  validAsset = true
  acceptableAssets: Record<string, Prototype> = {}

  get Mode () {
    return Mode
  }

  get canClose () {
    return !this.mode
  }

  get errors () {
    const invalidTitle = !this.link.title.trim()
    const invalidUrl = !A.isValidUrl(this.link.url)
    return {
      title: invalidTitle ? 'Please enter a title for your link.' : '',
      url: invalidUrl ? 'Please enter a valid url.' : ''
    }
  }

  setAcceptableAssets () {
    const allAssets = Object.entries(this.assets)
    const validAssets = allAssets.reduce((acc: Record<string, Prototype>, [assetId, asset]) => {
      if (this.isValidAsset(asset)) {
        acc[assetId] = asset
      }
      return acc
    }, {})
    this.acceptableAssets = validAssets
  }

  isValidAsset (asset: Prototype) {
    return asset.assetType !== 'url'
  }

  get isValidLink () {
    return !this.errors.title && !this.errors.url
  }

  mounted () {
    this.checkForSelectedAssetId()
  }

  @Watch('selectedAssetId')
  checkForSelectedAssetId () {
    if (this.selectedAssetId && !this.assets[this.selectedAssetId]) {
      console.error(`No asset found with id ${this.selectedAssetId}`)
    }

    this.setAcceptableAssets()
  }

  reset () {
    this.resetFields()
    this.validAsset = true
    this.submitted = false
  }

  resetFields () {
    this.link = emptyLink()
  }

  resetValidation () {
    this.validAsset = true
    this.submitted = false
  }

  validate () {
    this.submitted = true
    return this.isValidLink && this.selectedAssetId
  }

  pickFile () {
    (this.$refs.file as HTMLElement).click()
  }

  async filePicked (event: Event) {
    const inputElement = event.target as HTMLInputElement
    if (!inputElement.files || !inputElement.files.length) return
    const file = inputElement.files[0]
    if (this.validateFileType(file)) {
      const asset = await upload(file)
      const gqlAsset = {
        assetType: asset.asset_type,
        url: asset.url,
        title: asset.title
      }
      this.selectNewAsset(gqlAsset)
    } else {
      this.validAsset = false
    }
  }

  validateFileType (file:File) {
    return (/(png|jpg|jpeg|gif|bmp|tiff|psd|raw)$/.test(file.type))
  }

  removeAsset () {
    const assetId = this.selectedAssetId
    this.reset()
    this.$emit('removeAsset', assetId)
    this.currentMode = this.mode
  }

  selectNewAsset (asset: Omit<Prototype, 'id'>) {
    this.$emit('newAsset', asset)
  }

  applyExisting () {
    this.$emit('selectAsset', this.selectedExistingAssetID)
    this.selectedExistingAssetID = null
  }
}
